import { render } from "./RegisterButton.vue?vue&type=template&id=74224769&scoped=true&ts=true"
import script from "./RegisterButton.vue?vue&type=script&lang=ts"
export * from "./RegisterButton.vue?vue&type=script&lang=ts"

import "./RegisterButton.vue?vue&type=style&index=0&id=74224769&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74224769"]])

export default __exports__